export default __webpack_public_path__ + "static/media/niche.48a1f64f.gif";